/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export enum OrderState {
  PREPARE = "PREPARE",
  READY = "READY",
  DELIVERING = "DELIVERING",
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED",
}

export enum DeliveryStatus {
  FOOD_COLLECTED = "FOOD_COLLECTED",
  ORDER_EXECUTING = "ORDER_EXECUTING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  CANCELLED_OPERATOR = "CANCELLED_OPERATOR",
  CANCELLED_PASSENGER = "CANCELLED_PASSENGER",
  CANCELLED_MAX = "CANCELLED_MAX",
  CANCELLED_DRIVER = "CANCELLED_DRIVER",
  FAILED = "FAILED",
  REFUNDED = "REFUNDED",
}

export const DeliveryStatusName = new Map<string, string>([
  ["FOOD_COLLECTED", "outForDelivery"],
  ["ORDER_EXECUTING", "outForDelivery"],
  ["COMPLETED", "completed"],
  ["CANCELLED", "cancelled"],
  ["CANCELLED_OPERATOR", "cancelled"],
  ["CANCELLED_PASSENGER", "cancelled"],
  ["CANCELLED_MAX", "cancelled"],
  ["CANCELLED_DRIVER", "cancelled"],
  ["FAILED", "cancelled"],
  ["REFUNDED", "refunded"],
])

export enum OrderStateBackend {
  created = "ALLOCATING",
  OrderInPrepare = "ORDER_IN_PREPARE",
  OrderExecuting = "ORDER_EXECUTING",
  completed = "COMPLETED",
  cancelled = "CANCELLED",
  failed = "FAILED",
  unknown = "UNKNOWN",
  refunded = "REFUNDED",
}

export enum OrderDeliveryStateBackend {
  created = "NEW",
  allocating = "ALLOCATING",
  pickingUp = "PICKING_UP",
  driverAtStore = "DRIVER_AT_STORE",
  foodCollected = "FOOD_COLLECTED",
  driverArrived = "DRIVER_ARRIVED",
  completed = "COMPLETED",
  cancelled = "CANCELLED",
  failed = "FAILED",
  unknown = "UNKNOWN",
}

export enum PreparationTaskpoolStatusBackend {
  scheduled = "SCHEDULED",
  completed = "COMPLETED",
}

export enum OrderPageType {
  PREPARING = "Preparing",
  PREPARINGV2 = "PreparingV2",
  DELIVERING = "Delivering",
  READY = "Ready",
  UPCOMING = "Upcoming",
  COMPLETED = "Completed",
}

export enum GeAllocationStatus {
  AllocatingStatus = 1,
  GeNotFoundStatus = 3,
}

export const CutleryValue = new Map<number, string>([
  [0, ""],
  [1, "needCutlery"],
  [2, "dontNeedCutlery"],
])
